import { requestFunnel } from '@/application/api';

export const avatar = {
  baseURL: requestFunnel.defaults.baseURL,
  URL: userId => `${requestFunnel.defaults.baseURL}/user/${userId}/avatar`
};
